import { HunterPrerequisiteType } from "Infrastructure/Api/Api";
import z from "zod";

export const hunterPrerequisitesFormSchema = z.object({
  items: z.array(
    z.object({
      prerequisiteType: z.enum(HunterPrerequisiteType),
      isCompleted: z.boolean(),
      note: z.string().max(500).nullish(),
    }),
  ),
});

export type FormValues = z.infer<typeof hunterPrerequisitesFormSchema>;
